module.exports = (state, action) => {
  const { labelId } = action.payload
  if (labelId !== undefined) {
    // Instead of an object, we could use a Map, so we make sure we only remove each box once.
    const labelToDelete = Object.values(state.labels).find(label => label.composedid === labelId)
    if (!labelToDelete) { return }
    delete state.labels[labelToDelete?.id]
    state.labelsCount = state.labelsCount - 1
    return state
  } else {
    throw new Error('Cannot delete label with id: undefined')
  }
}
